<script setup lang="ts">
defineProps<{
    isOpen: boolean
    title: string
    message: string
    loading?: boolean
}>()

defineEmits(['close', 'confirm'])
</script>

<template>
    <div v-if="isOpen" class="fixed inset-0 z-[60] flex items-center justify-center p-4">
        <!-- Backdrop -->
        <div class="absolute inset-0 bg-black/50" @click="$emit('close')"></div>

        <!-- Modal -->
        <div class="relative bg-cc-elevated rounded-cc shadow-xl max-w-sm w-full p-6 animate-fade-in-up border border-cc-border">
            <h3 class="text-lg font-bold text-cc-text mb-2">{{ title }}</h3>
            <p class="text-cc-text-secondary mb-6">{{ message }}</p>

            <div class="flex justify-end gap-3">
                <button 
                    @click="$emit('close')" 
                    class="px-4 py-2 text-cc-text-secondary font-medium hover:bg-cc-hover rounded-lg transition-colors"
                >
                    Cancel
                </button>
                <button 
                    @click="$emit('confirm')" 
                    :disabled="loading"
                    class="px-4 py-2 bg-cc-danger hover:opacity-90 text-white font-medium rounded-lg transition-colors flex items-center gap-2"
                >
                    <span v-if="loading" class="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span>
                    {{ loading ? 'Deleting...' : 'Delete' }}
                </button>
            </div>
        </div>
    </div>
</template>
